import React from 'react';
import { createPortal } from 'react-dom';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import style from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import getLocal from '@/app/utils/i18n';

interface Props {
    show: boolean;
    onClose: () => void;
}

const Dialog: React.FC<Props> = ({ show, onClose }) => {
    const { t } = useLang('theProduct.SectionD.dialog');
    const { locale = 'us' } = getLocal();
    return show
        ? createPortal(
              <div className={style.comp}>
                  <div className="inner">
                      <div className="body">
                          <img
                              className="close"
                              onClick={onClose}
                              src="https://websiteoss.ecoflow.com/upload/image/1740466232448/close_circle_fill.png"
                              alt=""
                          />
                          <EcoSectionCommon label={t('label')} title={t('title')} desc={t('desc')} />
                          <EcoSpaceSmall />
                          {t('chartTitle') && (
                              <>
                                  <div className="eco-section-desc" style={{ textAlign: 'center' }}>
                                      {t('chartTitle')}
                                  </div>
                                  <EcoSpaceSmall />
                              </>
                          )}
                          <div className="chart-container">
                              <EcoImg
                                  className="chart"
                                  pc={
                                      locale === 'us'
                                          ? 'https://websiteoss.ecoflow.com/upload/image/1745310246946/us.jpg'
                                          : 'https://websiteoss.ecoflow.com/upload/image/1745310246451/gs.jpg'
                                  }
                                  pad={
                                      locale === 'us'
                                          ? 'https://websiteoss.ecoflow.com/upload/image/1745310246946/us.jpg'
                                          : 'https://websiteoss.ecoflow.com/upload/image/1745310246451/gs.jpg'
                                  }
                                  h5={
                                      locale === 'us'
                                          ? 'https://websiteoss.ecoflow.com/upload/image/1745310246646/us-h5.jpg'
                                          : 'https://websiteoss.ecoflow.com/upload/image/1745310246376/gs-h5.jpg'
                                  }
                              />
                              <div className="wd">{t('wd')}</div>
                              <div className="time">{t('time')}</div>
                              <div className="list">
                                  <div className="list-item">
                                      <div className="label"></div>
                                      <div className="text">{t('name1')}</div>
                                  </div>
                                  <div className="list-item">
                                      <div className="label"></div>
                                      <div className="text">{t('name2')}</div>
                                  </div>
                              </div>
                          </div>
                          <div className="list2">
                              <div className="list-item">
                                  <div className="label"></div>
                                  <div className="text">{t('name1')}</div>
                              </div>
                              <div className="list-item">
                                  <div className="label"></div>
                                  <div className="text">{t('name2')}</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>,
              document.body,
          )
        : null;
};
export default Dialog;
